<template>
  <div class="chooseStore">
    <el-row class="common-box">
      <div class="common-box-btn clearfix">
        <h2 class="floatl">选择门店</h2>
        <el-button type="primary" class="storeBtns" @click="downloadTem">下载模板</el-button>
        <el-button type="primary" class="storeBtns" @click="uploadDialog=true;">导入门店</el-button>
        <el-button type="primary" class="storeBtns" style="width:120px;background: #2d2c7a"
                   @click="keyImport(true)">
          卖进表一键导入
        </el-button>
      </div>
      <div class="common-search" style="padding: 10px 20px 0">
        <el-form :inline="true" label-width="70px" class="formInline" size="mini">
          <el-col :span="16">
            <el-form-item label="门店编码">
              <el-input v-model="formData.storeCode" placeholder="请输入门店编码..." :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="门店名称">
              <el-input v-model="formData.storeName" placeholder="请输入门店名称..." :maxlength="30"></el-input>
            </el-form-item>
            <el-button type="primary" class="storeBtns"
                       style="width:60px;background: #2d2c7a;border-radius: 5px;height:28px;line-height:28px;margin-top: 2px"
                       @click="getData(true)">搜索
            </el-button>
          </el-col>
          <!--				<el-col :span="8" style="text-align: right">
                              <el-form-item label="门店编码">
                                 <el-input v-model="formData.code" placeholder="请输入精确的门店编码..." :maxlength="30"></el-input>
                              </el-form-item>
                              <el-button type="primary" class="storeBtns" style="background: #2d2c7a;border-radius: 5px;height:28px;line-height:28px;margin-top: 2px" @click="addStore" v-loading="listLoadingBtn" element-loading-spinner="el-icon-loading">添加门店</el-button>
                          </el-col>-->
        </el-form>
      </div>
      <div class="common-box-body">
        <el-table class="limitManagerTable table-expand" style="width: 100%" :data="tableData" size="small"
                  v-loading="listLoading" element-loading-text="拼命加载中" border
                  header-row-class-name="table-header" ref="selStoreTable" @select="selectStoreChange" @select-all="selectStoreAllChange" >
          <el-table-column type="selection" width="50" align="center" fixed></el-table-column>
          <el-table-column type="index" width="50" align="center"></el-table-column>
          <el-table-column width="100" prop="crmDiv.provinceAdName" label="省"
                           align="center"></el-table-column>
          <el-table-column width="100" label="市" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.crmDiv.cityAdName || scope.row.crmDiv.adName}}</span>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="channel" label="终端" align="center"></el-table-column>
          <el-table-column width="160" prop="system" label="系统" align="center"></el-table-column>
          <el-table-column width="200" label="门店编码" align="center">
            <template slot-scope="scope">
              <span :style="storeCodeColor ? 'color:red' : ''">{{scope.row.storeCode}}</span>
            </template>
          </el-table-column>
          <el-table-column width="200" label="门店名称" align="center">
            <template slot-scope="scope">
              <span :style="storeNameColor ? 'color:red' : ''">{{scope.row.storeName}}</span>
            </template>
          </el-table-column>
          <el-table-column width="160" prop="scheduleNum" label="卖进序号" align="center"></el-table-column>
          <el-table-column width="200" prop="address" label="门店地址" align="center"></el-table-column>
          <el-table-column width="160" prop="planNumber" label="计划人数" align="center">
            <!-- <template slot-scope="scope">
                <el-input v-model.number="scope.row.planNumber" placeholder="请输入数字..." @blur="checkValue(scope.row)" max="150" min="0"></el-input>
            </template> -->
          </el-table-column>
          <el-table-column width="160" prop="recruitsNumber" label="招聘人数" align="center">
            <!-- <template slot-scope="scope">
                <el-input v-model.number="scope.row.recruitsNumber" placeholder="请输入数字..." @blur="checkValue(scope.row)" max="150" min="0"></el-input>
            </template> -->
          </el-table-column>
          <el-table-column width="160" prop="requirementsStart" label="开始时间" align="center">
            <!-- <template slot-scope="scope">
                <el-date-picker
               v-model="scope.row.requirementsStart"
               type="date"
               :clearable="true"
               value-format="yyyy-MM-dd"
               placeholder="开始时间"
               >
             </el-date-picker>
            </template> -->
          </el-table-column>
          <el-table-column width="160" prop="requirementsEnd" label="结束时间" align="center">
            <!-- <template slot-scope="scope">
                <el-date-picker
               v-model="scope.row.requirementsEnd"
               type="date"
               :clearable="true"
               value-format="yyyy-MM-dd"
               placeholder="结束时间">
             </el-date-picker>
            </template> -->
          </el-table-column>
          <!--  <el-table-column width="300" prop="remark" label="备注" align="center">
                   <template slot-scope="scope">
                       <el-input v-model="scope.row.remark" placeholder="请输入备注内容..."></el-input>
                   </template>
           </el-table-column> -->
          <el-table-column fixed="right" label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="jobEdits(scope.row,scope.$index)">任务编辑
              </el-button>
              <span class="cutLine"></span>
              <el-button type="text" size="small" @click="delrow(scope.$index,tableData)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin: 15px;">
            <el-button type="primary" @click="selStore('page')" size="small">选中本页</el-button>
            <el-button type="primary" @click="selStore('all')" size="small">选中全部</el-button>
            <el-button type="primary" @click="selStore('cancel')" size="small">取消选中</el-button>
            <span style="font-size: 14px;vertical-align: middle;margin-left: 10px;">已选择{{selStoreCnt}}家门店</span>
        </el-row>
        <!-- 分页 -->
        <el-pagination class="pagination table-pagination" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" :current-page="formData.pageNo"
                       :page-sizes="[10, 20, 30, 40]" :page-size="formData.pageSize"
                       layout="slot, total, sizes, prev, pager, next, jumper" :total="total"
                       style="margin-top: -20px;margin-bottom: -17px">
        </el-pagination>
      </div>
    </el-row>
    <el-row style="margin-bottom: 15px;">
      <div class="btns">
        <el-button type="text" @click="cancelPubStore">取消</el-button>
        <el-button type="primary" class="sureBtn" @click="pubStore">发布选中</el-button>
      </div>
    </el-row>

    <!-- 添加门店/任务编辑dialog -->
    <el-dialog
        :title="dialogTitle"
        class="quitDialog dialog"
        width="1000px"
        :center="true"
        :show-close="false"
        :visible.sync="jobEdit"
        top="17vh">
      <div class="dialogContent">
        <!-- 门店信息 -->
        <div v-if="dialogTitle == '添加门店'" class="storeInformation">
          <div class="detailInformation">
            <div class="areaData">
              {{storeInformation.crmDiv.provinceAdName}}
            </div>
            <div class="blank"></div>
            <div class="area">
              省份
            </div>
          </div>
          <div class="detailInformation">
            <div class="areaData">
              {{storeInformation.crmDiv.cityAdName}}
            </div>
            <div class="blank"></div>
            <div class="area">
              城市
            </div>
          </div>
          <div class="detailInformation">
            <div class="areaData">
              {{storeInformation.channel}}
            </div>
            <div class="blank"></div>
            <div class="area">
              终端
            </div>
          </div>
          <div class="detailInformation">
            <div class="areaData">
              {{storeInformation.system}}
            </div>
            <div class="blank"></div>
            <div class="area">
              系统
            </div>
          </div>
          <div class="detailInformation" style="width:230px">
            <div class="areaData">
              {{storeInformation.storeName}}
            </div>
            <div class="blank"></div>
            <div class="area">
              门店名称
            </div>
          </div>
          <div class="detailInformation" style="width:230px;border:0">
            <div class="areaData">
              {{storeInformation.address}}
            </div>
            <div class="blank"></div>
            <div class="area">
              门店地址
            </div>
          </div>
        </div>
        <!-- 任务设置 -->
        <div class="recruitmentSettings">
          <div class="recruitmentSettingsTitle">
            任务设置
          </div>
          <div class="recruitmentSettingsDetailed">
            <el-form label-width="80px" label-position="right">
              <el-row>
                <!-- <el-col :span="5" style="margin-left: 10px">
                  <el-form-item label="计划人数">
                    <el-input style="width:105px;" v-model.number="jobEditObj.planNumber"
                              placeholder="请输入数字..." :disabled="readOnly"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5" style="margin-left: 10px">
                  <el-form-item label="招聘人数">
                    <el-input style="width:105px;" v-model.number="jobEditObj.recruitsNumber"
                              placeholder="请输入数字..." :disabled="readOnly"></el-input>
                  </el-form-item>
                </el-col> -->
                <el-col :span="6" style="margin-left: 10px">
                  <el-form-item label="开始时间">
                    <el-date-picker
                        :disabled="readOnly"
                        type="date"
                        :clearable="true"
                        v-model="jobEditObj.requirementsStart"
                        style="width:150px"
                        value-format="yyyy-MM-dd"
                        :editable="false"
                        placeholder="开始时间">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6" style="margin-left: 20px">
                  <el-form-item label="结束时间">
                    <el-date-picker
                        :disabled="readOnly"
                        type="date"
                        :clearable="true"
                        v-model="jobEditObj.requirementsEnd"
                        style="width:150px"
                        value-format="yyyy-MM-dd"
                        :editable="false"
                        placeholder="结束时间">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row style="margin-top: 10px;padding-left:11px">
                  <el-form-item label="备注">
                      <el-input type="textarea" :rows="3" style="width:88.2%" v-model="jobEditObj.remark" placeholder="请输入数字..."></el-input>
                  </el-form-item>
              </el-row> -->
            </el-form>
          </div>
        </div>
        <!-- 调整薪酬 -->
        <!-- <div class="recruitmentSettings">
          <div class="recruitmentSettingsTitle">
            调整薪酬
          </div>
          <div class="recruitmentSettingsDetailed">
            <el-form label-width="90px" label-position="right">
              <el-row>
                <el-col :span="15">
                  <el-form-item label="岗位薪水" :required="true">
                    <el-radio v-model="publicStore2.salaryType" :label="1" style="width:30%">
                      日薪
                      <el-input v-model="publicStore2.daySalary"
                                :disabled="publicStore2.daySalaryStatus" size="mini"
                                class="salaryType" placeholder="请输入数字..."></el-input>
                    </el-radio>
                    <el-radio v-model="publicStore2.salaryType" :label="2" style="width:30%">
                      月薪
                      <el-input v-model="publicStore2.monthSalary"
                                :disabled="publicStore2.monthSalaryStatus" size="mini"
                                class="salaryType" placeholder="请输入数字..."></el-input>
                    </el-radio>
                    <el-radio v-model="publicStore2.salaryType" :label="3">面议</el-radio>
                  </el-form-item>
                </el-col>
                <el-col :span="7" style="margin-left:50px">
                  <el-form-item label="结算方式" :required="true">
                    <el-select v-model="publicStore2.salarySettlement" size="mini"
                               class="salaryType2" placeholder="请选择..." :clearable="true">
                      <el-option
                          v-for="item in salarySettlementOptions"
                          :key="item.id"
                          :label="item.masterName"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div> -->
        <!-- 推送设定 -->
        <div class="recruitmentSettings">
          <div class="recruitmentSettingsTitle">
            推送设定
          </div>
          <div class="recruitmentSettingsDetailed">
            <el-form label-width="80px" label-position="right">
              <el-row>
                <div class="checkGround">
                  <el-checkbox v-model="labelPush">标签推送</el-checkbox>
                  <el-checkbox v-model="designatedPromoters" @change="promotersStatus">
                    指定促销员推送
                    <el-button :disabled="!designatedPromoters" type="primary" size="mini"
                               class="ckeckPromoters" @click="checkPromoters(dialogTitle)">选择促销员
                    </el-button>
                  </el-checkbox>
                </div>
              </el-row>
              <el-row>
                <div class="isckeckPromoters"
                     v-if="isckeckPromotersList&&isckeckPromotersList.length > 0">
                  <div class="isckeckPromotersTitle">已选促销员 :</div>
                  <div class="isckeckPromotersContent">
                    <div class="tag-list">
                      <div class="tag-item" v-for="(item,index) in isckeckPromotersList" :key="item.id">
                        {{item.name}}
                        <span class="remove-btn" @click="deleteLabel(index,'ed')"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-row>
            </el-form>
          </div>
        </div>
        <!-- 联系信息 -->
        <div class="recruitmentSettings">
          <div class="recruitmentSettingsTitle">
            联系人信息
          </div>
          <div class="recruitmentSettingsDetailed">
            <el-form label-width="100px" label-position="right">
              <el-row>
                <el-col :span="7">
                  <el-form-item label="联系人姓名">
                    <el-input style="width:155px;" v-model.number="jobEditObj.moName" placeholder="请输入联系人姓名..."></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7" style="margin-left: 50px!important;">
                  <el-form-item label="联系人电话">
                    <el-input style="width:155px;" v-model.number="jobEditObj.moTel" placeholder="请输入联系人电话..."></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <!-- 调整可见范围 -->
        <!--180713铎哥说用户还没想好这块怎么做，所以先隐藏掉。其值直接取前页，其他未修改，逻辑未注释掉-->
        <!--另外还有岗位管理和发布岗位第一页里面有可见范围设定，也都已经注掉-->
        <!--<div class="recruitmentSettings">
          <div class="recruitmentSettingsTitle">
            调整可见范围
          </div>
          <div class="recruitmentSettingsDetailed">
            <el-form label-width="100px" label-position="right">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="星级">
                    <el-select v-model="publicStore2.starRating" size="mini" class="rangeSetting1"
                               placeholder="请选择...">
                      <el-option
                          v-for="item in starRatingOptions"
                          :key="item.id"
                          :label="item.rankName"
                          :value="item.id">
                      </el-option>
                    </el-select>
                    <span
                        style="width:90px;text-align: left;font-size: 14px;color: #606266;position:relative;top:2px;left:5px">级别级以上</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="信用分值下限" style="margin-left: 20px">
                    <el-input v-model.number="publicStore2.crescoreMin" size="mini"
                              class="trustArae" placeholder="分"
                              style="margin-left: 10px"></el-input>
                    &lt;!&ndash;								           	—
                                                                   <el-input v-model.number="publicStore2.crescoreMax"  size="mini" class="trustArae"  placeholder="分"></el-input>&ndash;&gt;
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <div style="margin:6px 0 0 0">
                    &lt;!&ndash; <el-radio-group v-model="publicStore2.searchType" style="margin-top:5px">
                      <el-radio :label="1">粉丝可见</el-radio>
                      <el-radio :label="2">会员可见</el-radio>
                  </el-radio-group> &ndash;&gt;
                    <span class="formLabel"><span class="required">* </span>账号身份：</span>
                    &lt;!&ndash;<span class="required">* </span>&ndash;&gt;
                    <el-checkbox-group v-model="publicStore2.searchType"
                                       style="margin-top:5px;width:60%;display:inline-block">
                      <el-checkbox label="粉丝"></el-checkbox>
                      <el-checkbox label="会员" style="margin-left: 20px"></el-checkbox>
                    </el-checkbox-group>


                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>-->
      </div>
      <span slot="footer" class="dialog-footer">
		    <el-button type="text" @click="jobEditCancelPub">取 消</el-button>
		    <el-button class="dialog-btn" type="primary" @click="jobEditSurePub">发布</el-button>
		  </span>
    </el-dialog>

    <!-- 选择促销员dialog -->
    <el-dialog
        title="添加促销员"
        v-if="addPromoterDialog"
        :visible="true"
        class="quitDialog dialog"
        width="1000px"
        :center="true"
        :show-close="false"
    >
      <div class="dialogContent" style="margin:0">
        <div class="addPromoter">
          <div class="addPromoterDetailed">
            <el-row>
              <div class="isckeckPromoters" v-if="checkingPromotersList&&checkingPromotersList.length > 0">
                <div class="isckeckPromotersTitle">已选促销员 :</div>
                <div class="isckeckPromotersContent">
                  <div class="tag-list">
                    <div class="tag-item" v-for="(item,index) in checkingPromotersList" :key="item.id">
                      {{item.name}} <span class="remove-btn" @click="deleteLabel(index,'ing')"></span>
                    </div>
                  </div>
                </div>
              </div>
            </el-row>
            <el-row>
              <el-form ref="paramForm" :model="paramForm" :inline="true" label-width="60px"
                       class="formInline" size="mini" :rules="rules">
                <el-form-item label="姓名" prop="name" style="margin-right:20px">
                  <el-input v-model="paramForm.name" placeholder="请输入..." style="width:160px"
                            :maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="身份证" prop="idcard">
                  <el-input v-model="paramForm.idcard" placeholder="请输入..." style="width:160px"
                            :maxlength="18"></el-input>
                </el-form-item>
                <el-form-item label="年龄" style="margin-bottom: 0; margin-right:0">
                  <el-form-item prop="ageMin" style="width:60px;margin: 0; padding:0">
                    <el-input v-model.number="paramForm.ageMin" placeholder="岁" style="width:60px"
                              class="small-input"></el-input>
                  </el-form-item>
                  -
                  <el-form-item prop="ageMax">
                    <el-input v-model.number="paramForm.ageMax" placeholder="岁" style="width:60px"
                              class="small-input"></el-input>
                  </el-form-item>
                </el-form-item>
                <el-form-item label="身高" style="margin-bottom: 0; margin-right:0">
                  <el-form-item prop="heightMin" style="width:60px;margin: 0; padding:0">
                    <el-input v-model.number="paramForm.heightMin" placeholder="CM"
                              style="width:60px" class="small-input"></el-input>
                  </el-form-item>
                  -
                  <el-form-item prop="heightMax">
                    <el-input v-model.number="paramForm.heightMax" placeholder="CM"
                              style="width:60px" class="small-input"></el-input>
                  </el-form-item>
                </el-form-item>
                <el-form-item label="促销员编号" prop="empCode">
                  <el-input v-model="paramForm.empCode" placeholder="请输入..." style="width:160px"
                            :maxlength="50"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" class="filterPromoters"
                             @click="getDefaultPromotersData(dialogTitle,'tableChange')">筛选
                  </el-button>
                </el-form-item>
              </el-form>
            </el-row>
            <el-row>
              <div class="tableContent">
                <div class="table" style="padding:10px">
                  <el-table style="width: 100%;" max-height="350" :data="promotersTableData"
                            size="small" v-loading="promotersListLoading" element-loading-text="拼命加载中"
                            border header-row-class-name="table-header" @select="selectChange"
                            @select-all="selectAllChange" ref="salesmuli">
                    <el-table-column type="selection" width="50" align="center"></el-table-column>
                    <el-table-column type="index" width="50" align="center"></el-table-column>
                    <el-table-column prop="name" label="姓名" align="center"></el-table-column>
                    <el-table-column prop="empCode" label="促销员编号" align="center"></el-table-column>
                    <el-table-column prop="idCard" label="身份证号" align="center"
                                     :formatter="formatIdCard"></el-table-column>
                    <el-table-column prop="tel" label="手机号" align="center"
                                     :formatter="formatTel"></el-table-column>
                    <el-table-column prop="age" label="年龄（岁）" align="center"></el-table-column>
                    <el-table-column prop="height" label="身高（CM）" align="center"></el-table-column>
                  </el-table>
                  <!-- 分页 -->
                  <el-pagination class="pagination table-pagination"
                                 @size-change="promotersHandleSizeChange"
                                 @current-change="promotersHandleCurrentChange"
                                 :current-page="paramForm.pageNo" :page-sizes="[10, 20, 30, 40]"
                                 :page-size="paramForm.pageSize"
                                 layout="slot, total, sizes, prev, pager, next, jumper"
                                 :total="promotersTotal" style="padding:15px 0 8px">
                  </el-pagination>
                </div>
              </div>

            </el-row>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
		    <el-button type="text" @click="addPromoterDialog = false">取 消</el-button>
		    <el-button class="dialog-btn" type="primary" @click="addPromoter">确 定</el-button>
		  </span>
    </el-dialog>
    <!--上传对话框-->
    <el-dialog
        class="dialog" title="上传门店数据" :visible.sync="uploadDialog" width="500px" center
        :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="dialog-body" v-loading="uploadLoading" fullscreen="false">
        <el-upload
            action="/rest/StoreUpDownload/importStore"
            :before-upload="handlePreview"
            :on-success='handleSuccess'
            :on-error='handleError'
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
	        <el-button class="dialog-btn" size="small" @click="uploadDialog = false"
                     :disabled="uploadLoading">关 闭</el-button>
	      </span>
    </el-dialog>
  </div>
</template>

<script>
  //韩金辰 180713 整理逻辑
  import utils from '../../../common/js/util.js'
  import {mapMutations} from "vuex";

  export default {
    props: {
      jobInformation: {type: Object},
      proDuringTime: {type: Object},
    },
    data() {
      var _this = this;
      //number都能写错。。
      // 判读是否是数字的工具函数
      var validateNmuber = (rule, value, callback) => {
        if (isNaN(value)) {
          callback(new Error('请输入数字'));
        } else if (value < 0) {
          callback(new Error('输入值>0'));
        } else {
          callback();
        }
      };
      //判断年龄上限是否填写正确，在选择促销员弹框中
      var ageRange1 = (rule, value, callback) => {
        if (isNaN(value)) {
          callback(new Error('请输入数字'));
        } else if (value < _this.paramForm.ageMin) {
          callback(new Error('范围错误'));
        } else if (value > 70) {
          callback(new Error('年龄不正确'))
        } else {
          callback();
        }
      };
      //判断身高上限是否填写正确，在选择促销员弹框中
      var heightRange1 = (rule, value, callback) => {
        if (isNaN(value)) {
          callback(new Error('请输入数字'));
        } else if (value < _this.paramForm.heightMin) {
          callback(new Error('范围错误'));
        } else if (value > 250) {
          callback(new Error("身高不正确"))
        } else {
          callback();
        }
      };
      return {
        //dataintype有个问题，当点搜索仅搜到一个卖进表的数据，发布后正常会去门店表再搜索，
        //但目前是用数据类型区分而不是以操作方式区分，所以发布光之后不会再去门店表搜索而继续在卖进表里搜索，得到空集
        //用户未必不能接受，提的时候再说，就把dataintype以操作方式区分，再根据返回的editflg区分是门店表还是卖进表的数据
        dataInType: '',//如果是一键导入则是menDianBiao，手动是byHand，搜索可能同一键，也能能是menDianBiao
        readOnly: false,//卖进表导入后，如果招聘设置里有数据，则不允许编辑
        notOneKeyInData: [],//普通导入时，返回的全部数据

        //表单内除了详细信息以外的信息
        formData: {
          storeCode: null,//搜索用
          storeName: null,//搜索用
          code: null,//
          pageNo: 1,//当前页数
          pageSize: 10// 每页条数
        },
        total: null,//总条目
        tableData: [],//表单的详细信息
        selTableData: [],//记录选中的门店记录信息
        listLoading: false,//loading动画
        dialogTitle: null,//弹框标题（取消添加门店以后，没啥用了）


        // 任务编辑
        jobEdit: false,//整个弹框是否显示
        //单独任务编辑的数据先存在这里，确定后覆盖前页传来的数据，然后发布
        jobEditObj: {
          storeCode: null,//门店编码
          requirementsStart: null,//开始时间
          requirementsEnd: null,//结束时间
          recruitsNumber: null,//招聘人数
          // remark: null,
          //发布时间
          publishTime: (new Date()).getFullYear() + "-" + ((new Date()).getMonth() + 1 > 9 ? ((new Date()).getMonth() + 1) : ('0' + ((new Date()).getMonth() + 1))) + "-" + ((new Date()).getDate() > 9 ? ((new Date()).getDate()) : ('0' + ((new Date()).getDate()))),
          planNumber: null,//计划人数
          postType: null,//推送设定
          moName: null, // 联系人姓名
          moTel: null // 联系人电话
        },
        salarySettlementOptions: [],
        starRatingOptions: [],
        labelPush: false,//标签推送么
        designatedPromoters: false,//指定促销员推送么
        isckeckPromoters: false,//没见有用到
        isckeckPromotersList: [],// 已选促销员
        checkingPromotersList: [],// 已选促销员，但还没点确定，点确定则覆盖ischeckpromoterslist
        // 促销员IDS（用于发布）
        salesmanIdList: [],
        // 发布成功后删除对应的表格中的数据的标志位
        tableIndex: null,
        // 促销员来源标志位
        salesFlag: null,
        // 保存选择的促销员，是不实时响应的id数据，isckeckPromotersList是实时响应的已确认数据，checkingPromotersList是实施相应的未确定的数据
        salesManIds: [],


        storeInformation: {
          crmDiv: {
            provinceAdName: null,
            cityAdName: null
          },
          channel: null,
          system: null,
          storeName: '',
          address: null,
          storeCode: '',
        },

        // 添加促销员
        addPromoterDialog: false,
        paramForm: {
          name: null,
          idcard: null,
          heightMin: null,
          heightMax: null,
          ageMin: null,
          ageMax: null,
          empCode: null,
          pageNo: 1,
          pageSize: 10
        },
        promotersTotal: null,
        promotersListLoading: false,
        promotersTableData: [],
        rules: {
          name: [
            {max: 10, message: '不得超过6个字符', trigger: 'blur'}
          ],
          idcard: [
            {
              pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
              message: '请输入15位或18位身份证号',
              trigger: 'blur'
            }
          ],
          ageMin: [
            {validator: validateNmuber, trigger: 'blur'}
          ],
          heightMin: [
            {validator: validateNmuber, trigger: 'blur'}
          ],
          ageMax: [
            {validator: ageRange1, trigger: 'blur'}
          ],
          heightMax: [
            {validator: heightRange1, trigger: 'blur'}
          ],
        },
        selects: [],

        // 发布岗位需要的默认参数，是从发布岗位传过来的数据（的id转换版），在本页内应确保只读，严禁修改
        publicStore: {
          workCode: null,//岗位信息唯一标识
          projectId: null,
          posName: null,
          signId: null,
          customer: null,
          scheduleType: null,
          posDetail: null,
          salaryDetail: null,
          welfareDetail: null,
          requirements: null,
          salaryCycle: null,
          salary: null,
          salaryType: null,
          sex: null,
          moName: null,
          moTel: null,
          requirementsTel: null,
          searchType: null,
          crescoreMax: null,
          crescoreMin: null,
          signIdList: [],
          rankRuleId: null,
          publishUserId: sessionStorage.getItem('sysUserId')
        },
        //在选择门店任务编辑里的岗位信息，发布时获取此信息
        //publicStore2与jobeditobj都是要发的数据，分开是因为后台传参要求
        publicStore2: {
          salaryType: null,
          daySalary: null,
          daySalaryStatus: true,
          monthSalary: null,
          monthSalaryStatus: true,
          salarySettlement: null,
          starRating: null,
          crescoreMax: null,
          crescoreMin: null,
          searchType: null,
        },
        // 添加门店loading
        listLoadingBtn: false,

        // 导入门店dialog标志位
        uploadDialog: false,
        uploadLoading: false,//上传控件loading


        // 使用门店名称或门店编码搜索时，对应的列会标红
        storeCodeColor: false,
        storeNameColor: false,
        empId: '',
        selStoreCnt:'0',//门店被选择数目,最大1000家
        selStoreAll:'false',//门店被全选状态，处理分页表现
        scheduleNum: null
      }
    },
    computed: {
      //工具类，纯转换
      searchType_trans() {
        if (this.jobInformation.searchType.length == 2) {
          return 0
        } else if (this.jobInformation.searchType.length == 0) {
          return ''
        }
        if (this.jobInformation.searchType[0] == "粉丝" && length == 1) {
          return 1
        }
        if (this.jobInformation.searchType[0] == "会员" && length == 1) {
          return 2
        }
      },
      searchType2_trans() {
        let arr = this.publicStore2.searchType
        let length = arr.length
        if (length == 2) {
          return 0
        } else if (length == 0) {
          return ''
        } else if (length == 1) {
          if (arr[0] == "粉丝") {
            return 1
          } else {// =='会员'
            return 2
          }
        }
      },
      postType_trans() {
        if (this.labelPush && this.designatedPromoters) {
          return 0
        } else if (this.labelPush) {
          return 2
        } else if (this.designatedPromoters) {
          return 3
        } else if (!this.labelPush && !this.designatedPromoters) {
          return 1
        }
      }
    },
    watch: {
      // 任务编辑-岗位薪水disabled
      'publicStore2.salaryType': function (newVal) {
        let pStore2 = this.publicStore2
        if (newVal == 1) {
          pStore2.daySalaryStatus = false
          pStore2.monthSalaryStatus = true
        } else if (newVal == 2) {
          pStore2.daySalaryStatus = true
          pStore2.monthSalaryStatus = false
        } else {
          pStore2.daySalaryStatus = true
          pStore2.monthSalaryStatus = true
        }
      },
    },
    mounted() {
      //获取当前的用户id信息
      let jobInfo = this.jobInformation
      let pStore = this.publicStore
      this.empId = sessionStorage.getItem('empPk')
      jobInfo.navState = 2
      // console.log('传入第二页的jobInformation', jobInfo)
      // console.log('传入第二页的proDuringTime', this.proDuringTime)
      //结算方式的下拉列表
      this.salarySettlementOptions = jobInfo.salarySettlementOptions
      //星级下拉列表
      this.starRatingOptions = jobInfo.starRatingOptions

      // 接下来从jobinfo里面读数据配置给publishStore
      //选择的标签checkboxids就是signidlist,前面页不知咋传的，每次更新是否勾选标签推送
      pStore.signIdList = jobInfo.checkboxIds.slice(0)
      // 岗位类型转成id（长短促等）
      jobInfo.jobTypeOptions.map(item => {
        if (item.signName == jobInfo.jobType) {
          pStore.signId = item.id
        }
      })
      //性别转换成id
      jobInfo.sexOptions.map(item => {
        if (item.sexName == jobInfo.sexName) {
          pStore.sex = item.id
        }
      })
      //档期类型转换成id（长期-做五休二等）
      jobInfo.dateTypeOptions.map(item => {
        if (item.masterName == jobInfo.dateType) {
          pStore.scheduleType = item.id
        }
      })
      //结算方式转换成id（日结周结月结等），publish2需要每次从publish更新
      jobInfo.salarySettlementOptions.map(item => {
        if (item.masterName == jobInfo.salarySettlement) {
          pStore.salaryCycle = item.id
        }
      })
      //星级转换成id（青铜白银），publish2需要每次从publish更新
      jobInfo.starRatingOptions.map(item => {
        if (item.rankName == jobInfo.starRating) {
          pStore.rankRuleId = item.id
        }
      })
      //读取岗位薪水（多少钱），publish2需要每次从publish更新
      if (jobInfo.salaryType == '1') {
        pStore.salary = jobInfo.daySalary
      } else if (jobInfo.salaryType == '2') {
        pStore.salary = jobInfo.monthSalary
      } else {
        pStore.salary = null
      }
      //默认的标签推送是否勾选
      this.labelPush = Boolean(pStore.signIdList.length != 0)

      //把可见范围（会员粉丝）转换成id，publish2使用的不是id形式，所以每次直接从jobinfo获取
      pStore.searchType = this.searchType_trans

      //以下是不转换直接读取的
      //其中需要publish2需要每次从publish更新的有
      pStore.salaryType = jobInfo.salaryType
      pStore.crescoreMin = jobInfo.crescoreMin
      //这些不需要每次更新
      pStore.projectId = jobInfo.projectId
      pStore.posName = jobInfo.posName
      pStore.customer = jobInfo.customer
      pStore.workCode = jobInfo.workCode
      pStore.salaryDetail = jobInfo.salaryDetail
      pStore.welfareDetail = jobInfo.welfareDetail
      pStore.posDetail = jobInfo.posDetail
      pStore.requirements = jobInfo.requirements
      pStore.moName = jobInfo.moName
      pStore.moTel = jobInfo.moTel
      pStore.requirementsTel = jobInfo.requirementsTel
      //其他还有月薪日新的金额的 是否可编辑，
      // 其他还有计划人数招聘人数，起止时间，都是从table的row读取的
      // produringTime用于校验岗位时间是否在项目时间之内
      // console.log('proDuringTime', this.proDuringTime)
    },
    methods: {
      /*
      工具类
      */
      //vuex相关，大概表示工作广场正在被编辑（这个岗位一旦发布过，在添加岗位页就不能再编辑）
      ...mapMutations(["workSquareIsEditMethods"]),
      //工具类，提示框
      myNotify(_this, type, normal, or) {
        utils.myNotify(_this, type, normal, or)
      },
      //工具类-手机号加星，使用外调的utils工具函数
      formatTel(row, column, cellValue) {
        return utils.plusXing(cellValue, 3, 4)
      },
      //工具类，身份证号加星，使用外调的utils工具函数
      formatIdCard(row, column, cellValue) {
        return utils.plusXing(cellValue, 6, 4)
      },
      /*
      页面基础功能
      */
      //获取数据，先判断xx，再取消搜索时纵向标红的样式，再清空表单详情，再请求后台查询门店
      //点搜索，改变页码，改变每页条目，可以触发此函数
      getData(resetPageNo) {
        if (resetPageNo) this.formData.pageNo = 1;
        this.tableData = []
        // 查询门店，再判断是否有关键字（有就是搜索），loading加请求数据，获取table详情和总计条目
        this.storeCodeColor = Boolean(this.formData.storeCode)
        this.storeNameColor = Boolean(this.formData.storeName)
        this.listLoading = true
        this.$http({
          method: "GET",
          url: "/rest/PublishedWork/searchStore",
          params: {
            workCode: this.publicStore.workCode,
            empId: this.empId,
            storeCode: this.formData.storeCode,
            storeName: this.formData.storeName,
            pageSize: this.formData.pageSize,
            pageNo: this.formData.pageNo,
            projectIpgId: this.jobInformation.projectIpgId,//（回头再看）
          }
        }).then(res => {
          this.listLoading = false
          let data = res.data
          if (data.list) {
            //这个接口默认在卖进表里搜索，搜不到才进入门店表搜索
            //不是从卖进表导入的则提供默认的计划和招聘人数
            if (data.editFlg) {
              data.list.map(item => {
                item.planNumber = 1;
                item.recruitsNumber = 3
                item.readOnly = false
              })
              this.dataInType = 'menDianBiao'
            } else {
              data.list.map(item => {
                //只要有一个是空值，则允许修改
                item.readOnly =
                  Boolean(item.planNumber) &&
                  Boolean(item.recruitsNumber) &&
                  Boolean(item.requirementsStart) &&
                  Boolean(item.requirementsEnd)
              })
              this.dataInType = 'maiJinBiao'
            }
            this.readOnly = !data.editFlg
            this.tableData = data.list
            this.total = data.countSize
          }
        }).then(res => {
          // 根据门店选择标识，判断当前是权限，还是page选
          if(this.selStoreAll == 'true') {
            if(this.formData.pageNo * this.formData.pageSize <= 1000) {
              var rows = this.tableData;
              rows.forEach(row => {
                this.$refs.selStoreTable.toggleRowSelection(row,true);
              });
            }else if(1000 < this.formData.pageNo * this.formData.pageSize <= 1000 + this.formData.pageSize) {
              var i = this.formData.pageSize - (this.formData.pageNo * this.formData.pageSize - 1000);
              var rows = this.tableData;
              rows.forEach(row => {
                if(i > 0) {
                  this.$refs.selStoreTable.toggleRowSelection(row,true);
                  i = i - 1;
                }
              });
            }
          } else {
            this.selStoreCnt = 0;
            this.selTableData = [];//清空选择的数据
          }
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          this.listLoading = false
        })
        // // 查询门店条数
        // this.$http({
        // 	method:"GET",
        // 	url:"/rest/PublishedWork/countSearchStore",
        // 	params:{
        // 		storeCode:this.formData.storeCode,
        // 		storeName:this.formData.storeName
        // 	}
        // }).then(res=>{
        // 	let data = data
        // 	this.total = data
        // })
      },
      // 取消发布门店，相当于切换到上一页，不清空前一页的数据
      cancelPubStore() {
        this.$emit('ReceiveState', 1)
      },
      // 删除一行数据
      delrow(index, rows) {
        this.$confirm('确认删除吗？', '提示', {}).then(() => {
          if (this.dataInType != 'byHand') {
            this.$http({
              method: "POST",
              url: "/rest/PublishedWork/deleteProjectStore",
              data: {
                "empId": this.empId,
                "workCode": this.publicStore.workCode,
                "storeCode": rows[index].storeCode,
              }
            }).then(res => {
              // console.log(res)
              if (res.data.message == '删除成功') {
                rows.splice(index, 1)
              }
            }).catch(err => {
              this.myNotify(this, 'error', err.response.message, '操作失败，请稍后重试')
            })
          } else {
            rows.splice(index, 1);
            let num = this.formData.pageSize * (this.formData.pageNo - 1) + index
            this.notOneKeyInData.splice(num, 1)
          }
        }).catch(() => {
        })
      },
      // 下载模板
      downloadTem() {
        location.href = utils.returnUrlHead('temp/') + 'excel/store_mould.xlsx';
        // 以前是请求的地址，现在直接写死

        // this.listLoading = true
        // this.$http({
        //   method: "POST",
        //   url: "/rest/StoreUpDownload/downloadStore",
        // }).then(res => {
        //   if (res && res.data && (res.data.code == 0 || res.data.code == null)) {
        //     location.href = utils.returnUrlHead() + res.data.message;
        //   }
        //
        //   this.listLoading = false
        // }).catch(err => {
        // this.myNotify(this, 'error', err.response.message, '查询失败，请稍后重试')
        //   this.listLoading = false
        // })
      },
      // 导入门店
      handleSuccess(response, file, fileList) {
        this.uploadLoading = false;
        this.storeCodeColor = false
        this.storeNameColor = false
        this.notOneKeyInData = response.lsw
        this.tableData = []
        this.formData.pageNo = 1;
        this.formData.pageSize = 10;
        this.tableData = this.notOneKeyInData.slice(0, 10)
        this.total = response.countSize

        this.dataInType = 'byHand'
        //因为传入之后立即加入到列表，所以新增：如果未成功则把本条删掉
        //现在改为，成功后不保留列表
        fileList.splice(0, 1);
        this.$alert(response.message, '提示', {
          dangerouslyUseHTMLString: true,
          callback: action => {
            this.uploadDialog = false;
          }
        })
      },
      handlePreview(file) {
        this.uploadLoading = true;
        // return this.$confirm("您确定导入门店吗？", "警告", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消"
        // })
      },
      handleError(err, response, fileList) {
        //因为常见的错误后台都在success中返回错误，所以这个很少用到
        this.uploadLoading = false;
        let msg = "文件上传失败";
        if (!response || !response.message) {
          msg = "请求超时，请稍后再试";
        } else {
          msg = response.message;
          msg = msg.split("。").join("\n");
        }
        this.$alert(msg, '提示', {
          dangerouslyUseHTMLString: true,
          callback: action => {
            this.uploadDialog = false;
          }
        })
      },
      //更新导入门店的table
      refreshDataByHand(length) {
        let num = this.formData.pageSize * (this.formData.pageNo - 1);
        if (length == 1) {//当是单独编辑-发布时
          num = num + this.tableIndex
        }
        this.notOneKeyInData.splice(num, length)

        //然后重新载入数据
        this.tableData = []
        this.tableData = this.notOneKeyInData.slice(num, num + this.formData.pageSize)
        //促销员页的重置
        this.paramForm.pageNo = 1;
        this.paramForm.pageSize = 10;
        this.total = this.notOneKeyInData.length
      },
      // 一键导入
      keyImport(resetPageNo) {
        if (resetPageNo) this.formData.pageNo = 1;
        let a = this.formData.storeCode
        let b = this.formData.storeName
        this.formData.storeCode = null
        this.formData.storeName = null
        if ((a == null ? '' : a) != "" || (b == null ? '' : b) != '' && this.formData.pageNo != 1) {
          this.formData.pageNo = 1
        }

        this.listLoading = true
        this.$http({
          method: "GET",
          url: "/rest/PublishedWork/importStore",
          params: {
            empId: this.empId,
            pageSize: this.formData.pageSize,
            pageNo: this.formData.pageNo,
            projectIpgId: this.jobInformation.projectIpgId,
            workCode: this.publicStore.workCode,
          }
        }).then(res => {
          let data = res.data
          if (data.workPosList) {
            data.workPosList.map(item => {
              //只要有一个是空值，则允许修改
              item.readOnly =
                Boolean(item.planNumber) &&
                Boolean(item.recruitsNumber) &&
                Boolean(item.requirementsStart) &&
                Boolean(item.requirementsEnd)
            })
            this.storeCodeColor = false
            this.storeNameColor = false
            this.tableData = data.workPosList
            this.total = data.countSize
            this.dataInType = 'maiJinBiao'
          }
          this.listLoading = false
        }).then(res => {
          // 根据门店选择标识，判断当前是权限，还是page选
          if(this.selStoreAll == 'true') {
            if(this.formData.pageNo * this.formData.pageSize <= 1000) {
              var rows = this.tableData;
              rows.forEach(row => {
                this.$refs.selStoreTable.toggleRowSelection(row,true);
              });
            }else if(1000 < this.formData.pageNo * this.formData.pageSize <= 1000 + this.formData.pageSize) {
              var i = this.formData.pageSize - (this.formData.pageNo * this.formData.pageSize - 1000);
              var rows = this.tableData;
              rows.forEach(row => {
                if(i > 0) {
                  this.$refs.selStoreTable.toggleRowSelection(row,true);
                  i = i - 1;
                }
              });
            }
          } else {
            this.selStoreCnt = 0;
            this.selTableData = [];//清空选择的数据
          }
        }).catch(err => {
          this.myNotify(this, 'error', err.response.message, '查询失败，请稍后重试')
          this.listLoading = false
        })
      },
      /*
      table相关功能
      */
      // 换页或者size切换
      handleSizeChange(val) {
        this.formData.pageSize = val
        if (this.dataInType == 'maiJinBiao') {
          this.keyImport(false)
        } else if (this.dataInType == 'menDianBiao') {
          this.getData(false)
        } else {//byHand
          this.tableData = this.notOneKeyInData.slice(0, val)
          this.formData.pageNo = 1

          // 根据门店选择标识，判断当前是权限，还是page选
          if(this.selStoreAll == 'true') {
            if(this.formData.pageNo * this.formData.pageSize <= 1000) {
              var rows = this.tableData;
              rows.forEach(row => {
                this.$refs.selStoreTable.toggleRowSelection(row,true);
              });
            }else if(1000 < this.formData.pageNo * this.formData.pageSize <= 1000 + this.formData.pageSize) {
              var i = this.formData.pageSize - (this.formData.pageNo * this.formData.pageSize - 1000);
              var rows = this.tableData;
              rows.forEach(row => {
                if(i > 0) {
                  this.$refs.selStoreTable.toggleRowSelection(row,true);
                  i = i - 1;
                }
              });
            }
          } else {
            this.selStoreCnt = 0;
            this.selTableData = [];//清空选择的数据
          }
        }
      },
      handleCurrentChange(val) {
        this.formData.pageNo = val
        if (this.dataInType == 'maiJinBiao') {
          this.keyImport(false)
        } else if (this.dataInType == 'menDianBiao') {
          this.getData(false)
        } else {//byHand
          let start = (val - 1) * this.formData.pageSize;
          let end = start + this.formData.pageSize;
          this.tableData = this.notOneKeyInData.slice(start, end)

          // 根据门店选择标识，判断当前是权限，还是page选
          if(this.selStoreAll == 'true') {
            if(this.formData.pageNo * this.formData.pageSize <= 1000) {
              var rows = this.tableData;
              rows.forEach(row => {
                this.$refs.selStoreTable.toggleRowSelection(row,true);
              });
            }else if(1000 < this.formData.pageNo * this.formData.pageSize <= 1000 + this.formData.pageSize) {
              var i = this.formData.pageSize - (this.formData.pageNo * this.formData.pageSize - 1000);
              var rows = this.tableData;
              rows.forEach(row => {
                if(i > 0) {
                  this.$refs.selStoreTable.toggleRowSelection(row,true);
                  i = i - 1;
                }
              });
            }
          } else {
            this.selStoreCnt = 0;
            this.selTableData = [];//清空选择的数据
          }
        }
      },
      /*
      发布相关
      */
      // 发布本页全部10条（或几条根据下面设置）门店，点击选择门店最下面发布按钮时触发
      pubStore() {
        // console.time("时间测试时间测试");
        // console.log(this.publicStore)
        if (this.selStoreAll == 'false' && this.selTableData.length == 0) {
          this.myNotify(this, 'warning', '请导入门店！')
          return false
        }
        //内容校验开始
        let time = {
          proStartT: new Date(this.proDuringTime.start).getTime(),
          proEndT: new Date(this.proDuringTime.end).getTime(),
          publishStart: '',
          publishEnd: '',
        }
        let arr = this.selTableData
        let arrLength = arr.length
        let hasErr = false;
        let isInt = /^\d+$/; // 非负整数
        let err = ''
        for (let i = 0; i < arrLength; i++) {
          if (!arr[i].planNumber || !isInt.test(arr[i].planNumber)) {
            hasErr = true
            err = '请输入正确的计划人数'
          } else if (!arr[i].recruitsNumber || !isInt.test(arr[i].recruitsNumber)) {
            hasErr = true
            err = '请输入正确的招聘人数'
          } else if (Number(arr[i].recruitsNumber) < Number(arr[i].planNumber)) {
            hasErr = true
            err = '招聘人数不应小于计划人数'
          } else if (arr[i].moName == null || arr[i].moName == '' || arr[i].moName == undefined) {
            hasErr = true;
            err = "请输入联系人姓名";
          } else if (arr[i].moTel == null || arr[i].moTel == '' || arr[i].moTel == undefined) {
            hasErr = true;
            err = "请输入联系人电话！";
          } else if (!(/^1[345789]\d{9}$/.test(arr[i].moTel)) && !(/^0\d{2,3}-\d{7,8}(-\d{1,6})?$/).test(arr[i].moTel)) {
            hasErr = true;
            err = '请输入正确的电话号!';
          } else {
            time.publishStart = new Date(arr[i].requirementsStart).getTime();
            time.publishEnd = new Date(arr[i].requirementsEnd).getTime();
            if (time.publishEnd < time.publishStart) {
              hasErr = true
              err = '开始时间应小于结束时间'
            } else if (time.publishEnd > time.proEndT) {
              hasErr = true
              err = '岗位结束时间应在项目时间范围内'
            } else if (time.publishStart < time.proStartT) {
              hasErr = true
              err = '岗位开始时间应在项目时间范围内'
            }
          }

          if (hasErr) {
            this.myNotify(this, 'warning', `本页第${i + 1}条内容错误，${err}`)
            return false
          }
        }
        //校验结束且通过
        let storeArr = []
        let date = new Date()
        let sysUserId = sessionStorage.getItem('sysUserId')
        this.selTableData.forEach((item, index, arr) => {
          let storeObj = {
            storeCode: item.storeCode,
            requirementsStart: item.requirementsStart,
            requirementsEnd: item.requirementsEnd,
            recruitsNumber: item.recruitsNumber,
            planNumber: item.planNumber,
            // remark:item.remark,
            publishTime: utils.dateTrans(date),
            publishUserId: sysUserId,
            postType: this.postType_trans,
            moName: item.moName,
            moTel: item.moTel,
            scheduleNum: item.scheduleNum
          }
          storeArr.push(storeObj)//本页面的10或几十条数据
        })
        this.publish(storeArr, 1)//
        // console.timeEnd("时间测试时间测试");//40条数据时，2ms完成以上所有逻辑，挺惊人的
      },
      //发布，任务编辑页发布 和直接发布 触发
      //param接受生效范围及部分配置信息，另一部分在publicStore里，type=1发布本页，=2单独发布 =3什么也不做
      publish(param, type, index) {
        // console.log('param', param)
        // console.log('publicStore', this.publicStore)
        //把设置的可见范围 存储为正式...。。。。以前写的，是错的，不应将变化更新到默认设置中，publicStore应杜绝修改
        // this.publicStore.searchType = this.searchType2_trans
        //后台根据workcode查询是否有项目存储过，1无，2有，现在不用这个接口也行，后台返回的（修改了接口）都是未发布过的
        //上面说的仅当一键导入时才正确，所以这接口不能删掉
        this.$http({
          method: "GET",
          url: "/rest/PublishedWork/searchWorkPosByCode",
          params: {
            workCode: this.publicStore.workCode
          }
        }).then(res => {
          if (res.data.message == 1) {
            //如果是未存储过的，则提示一下
            this.$confirm(' 点击确定该岗位会发布，如需修改请到岗位管理内进行编辑，是否继续？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.realPublish(param, true)
            }).catch(() => {
              //发布本页点取消，不弹出编辑框
              if (type == 2) {
                this.jobEdit = true
              }
            })
          } else {
            this.realPublish(param, false)
          }
        })
      },
      //仅为精简代码，publish专用
      realPublish(param, isPublished) {
        if (isPublished) {
          this.workSquareIsEditMethods(true)
        }//记录下本岗位已经发布过了，不能回到上一页再编辑
        this.listLoading = true
        const { otherPosDetail, otherRequirements } = this.jobInformation
        this.$http({
          method: "POST",
          url: "/rest/PublishedWork/savePublishedWorks",
          data: {
            posStoreInfoList: param,//决定生效范围，及一些其他信息
            workPosInfo: {
              ...this.publicStore,
              otherPosDetail,
              otherRequirements
            },//决定改成什么
            allPageFlg:this.selStoreAll,//是否是全选
            searchStoreInfo: {//数据筛选的条件
              workCode: this.publicStore.workCode,
              empId: this.empId,
              storeCode: this.formData.storeCode,
              storeName: this.formData.storeName,
              pageSize: this.formData.pageSize,
              pageNo: this.formData.pageNo,
              projectIpgId: this.jobInformation.projectIpgId,
            }
          }
        }).then(res => {
          //此loading顺序不能变
          this.listLoading = false
          if (!isPublished) {
            this.workSquareIsEditMethods(true)
          }

          if (this.dataInType == 'maiJinBiao') {
            //当是一键导入的数据，再次一键导入，并返回未导入的数据
            this.keyImport(true)
          } else if (this.dataInType == 'menDianBiao') {
            //当是搜索的数据，再次搜索，并返回未导入的数据
            this.getData(true)
          } else {//byHand
            this.refreshDataByHand(param.length)
          }
          this.selStoreCnt = 0;
          this.selTableData = [];//清空选择的数据
          this.myNotify(this, 'success', res, '操作成功')
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '操作失败，请稍后重试')
          this.listLoading = false
        })//下面这个catch前面的这一大段，跟下面的几乎一样，唯一区别是workSquareIsEditMethods的位置
      },
      // 任务编辑
      jobEdits(row, index) {
        this.dialogTitle = "任务编辑"
        this.jobEdit = true
        // this.jobEditObj.remark = row.remark
        // console.log(row.planNumber)
        //每次都获取默认的岗位薪水类型
        let pStore2 = this.publicStore2
        let pStore = this.publicStore
        let jobInfo = this.jobInformation
        let salaryType = pStore.salaryType
        // console.log("pStore2:" + JSON.stringify(pStore2));
        // console.log("pStore:" + JSON.stringify(pStore2));
        // console.log("jobInfo:" + JSON.stringify(jobInfo));
        // console.log("salaryType:" + JSON.stringify(salaryType));

        pStore2.salaryType = salaryType
        pStore2.daySalary = null
        pStore2.monthSalary = null
        if (salaryType == '1') {
          pStore2.daySalary = jobInfo.daySalary
        } else if (salaryType == '2') {
          pStore2.monthSalary = jobInfo.monthSalary
        }
        //薪水输入框的禁用状态在watch里面
        //每次更新信用分值下限
        pStore2.crescoreMin = pStore.crescoreMin
        //每次更新可见范围（会员粉丝），这里是从jobinfo获取，因为不要id形式
        pStore2.searchType = jobInfo.searchType
        //每次更新结算方式
        pStore2.salarySettlement = pStore.salaryCycle
        //每次更新星级
        pStore2.starRating = pStore.rankRuleId
        //每次恢复到默认的标签推送是否勾选
        this.labelPush = Boolean(pStore.signIdList.length != 0)

        //接下来从row获取数据
        let jobEdit = this.jobEditObj
        jobEdit.storeCode = row.storeCode//岗位编码，仅为了推送
        jobEdit.requirementsStart = row.requirementsStart//开始时间，展示及提送
        jobEdit.requirementsEnd = row.requirementsEnd//结束时间，展示及推送
        jobEdit.recruitsNumber = Number(row.recruitsNumber)//招聘人数，展示及推送
        jobEdit.planNumber = row.planNumber//计划人数，展示及推送
        jobEdit.moName = row.moName; // 联系人姓名
        jobEdit.moTel = row.moTel; // 联系人电话
        jobEdit.scheduleNum = row.scheduleNum; // 卖进序号
        this.tableIndex = index//第几行，仅为了手动导入时，推送后删除该行

        this.salesmanIdList = []//促销员id列表，在选择门店-任务编辑-选择促销员里面
        this.isckeckPromotersList = []//已选择的 促销员id列表，在选择门店-任务编辑-选择促销员里面
        this.designatedPromoters = false;//是否指定促销员推送，在选择门店-任务编辑里面
        this.readOnly = row.readOnly
      },
      // 任务编辑取消发布
      jobEditCancelPub() {
        this.jobEdit = false
      },
      // 任务编辑确认发布
      jobEditSurePub() {
        let storeItemEditObj = {
          salaryType: this.publicStore2.salaryType,
          salesmanIdList: this.salesmanIdList,
          searchType: this.searchType2_trans,//可见范围-如果修改了则后台会优先取这个值，发布本页的话
          crescoreMin: this.publicStore2.crescoreMin,//信用分下限
          rankRuleId: this.publicStore2.starRating,//星级
          salaryCycle: this.publicStore2.salarySettlement,
          salary: null,
          postType: this.postType_trans//推送类型
        }
        //把设置的可见范围 存储为正式
        //岗位薪水（类型）
        if (storeItemEditObj.salaryType == 1) {
          storeItemEditObj.salary = this.publicStore2.daySalary
        } else if (storeItemEditObj.salaryType == 2) {
          storeItemEditObj.salary = this.publicStore2.monthSalary
        } else {
          storeItemEditObj.salary = null
        }

        let param = Object.assign(this.jobEditObj, storeItemEditObj)
        // this.checkvalue(param)
        let paramArr = [];
        paramArr.push(param)

        let errMsg = '';
        let isInt = /^\d+$/; // 非负整数
        // console.log('jobEditObj', this.jobEditObj)
        let time = {
          proStartT: new Date(this.proDuringTime.start).getTime(),
          proEndT: new Date(this.proDuringTime.end).getTime(),
          publishStart: new Date(this.jobEditObj.requirementsStart).getTime(),
          publishEnd: new Date(this.jobEditObj.requirementsEnd).getTime(),
        }

        if (!this.jobEditObj.planNumber || !isInt.test(this.jobEditObj.planNumber)) {
          errMsg = '请输入正确的计划人数'
        } else if (!this.jobEditObj.recruitsNumber || !isInt.test(this.jobEditObj.recruitsNumber)) {
          errMsg = '请输入正确的招聘人数'
        } else if (Number(this.jobEditObj.recruitsNumber) < Number(this.jobEditObj.planNumber)) {
          errMsg = '招聘人数不应小于计划人数'
        } else if (storeItemEditObj.salaryType == 1 && (!this.publicStore2.daySalary || !isInt.test(this.publicStore2.daySalary))) {
          errMsg = '请输入正确的岗位薪水'
        } else if (storeItemEditObj.salaryType == 2 && (!this.publicStore2.monthSalary || !isInt.test(this.publicStore2.monthSalary))) {
          errMsg = '请输入正确的岗位薪水'
        } else if ((this.publicStore2.crescoreMin || this.publicStore2.crescoreMin == 0) && !isInt.test(this.publicStore2.crescoreMin)) {
          errMsg = '信用分值填写错误'
        } else if (time.publishEnd < time.publishStart) {
          errMsg = '开始时间应小于结束时间'
        } else if (time.publishEnd > time.proEndT) {
          errMsg = '岗位结束时间应在项目时间范围内'
        } else if (time.publishStart < time.proStartT) {
          errMsg = '岗位开始时间应在项目时间范围内'
        } else if (storeItemEditObj.searchType === '') {//他会返回012和''，只有''是无效的
          errMsg = '请选择粉丝可见或者会员可见'
        } else if (this.jobEditObj.moName == null || this.jobEditObj.moName == '' || this.jobEditObj.moName == undefined) {
          errMsg = "请输入联系人姓名";
        } else if (this.jobEditObj.moTel == null || this.jobEditObj.moTel == '' || this.jobEditObj.moTel == undefined) {
          errMsg = "请输入联系人电话！";
        } else if (!(/^1[345789]\d{9}$/.test(this.jobEditObj.moTel)) && !(/^0\d{2,3}-\d{7,8}(-\d{1,6})?$/).test(this.jobEditObj.moTel)) {
          errMsg = '请输入正确的电话号!';
        }

        if (errMsg !== '') {
          this.myNotify(this, 'warning', errMsg)
          return false
        }

        if (this.dialogTitle == "任务编辑") {
          this.publish(paramArr, 2);
        }
        //发布门店，现在不用了
        // else {
        //   this.publish(paramArr, 3)
        // }
        this.jobEdit = false
      },
      /*    选择促销员相关逻辑

            核心参数：selects(当前页table中已选择的数据)，
            checkingPromotersList（待确定的所有的已选择的数据），
            salesManIds（checking的id列表）以及列表的选中状态
            点击确定后将checking同步给ischeck
            搞清楚这几个参数再碰这块代码
       */
      // 任务编辑选择促销员
      checkPromoters(title) {
        // 弹出选择促销员dialog
        this.addPromoterDialog = true
        //现在要求第一次进入的时候，不搜索列表，就不走getDefaultPromotersData了，所以把这段单独拿出来显得代码整洁
        // this.getDefaultPromotersData(title, 'tableOpen')
        //先重置
        this.promotersTotal = null;
        this.promotersTableData = [];
        this.paramForm = {
          name: null,
          idcard: null,
          heightMin: null,
          heightMax: null,
          ageMin: null,
          ageMax: null,
          pageNo: 1,
          pageSize: 10
        }
        //只有选了促销员再次进入选择促销员弹框时，此map才有用,给选择促销员弹窗赋值
        this.checkingPromotersList = [];
        this.salesManIds = [];
        this.isckeckPromotersList.map((item) => {
          this.salesManIds.push(item.id)
          this.checkingPromotersList.push(item)
        })
      },
      // 任务编辑删除已选的促销员
      deleteLabel(index, type) {
        if (type == 'ed') {
          //把自己删掉就行了
          this.isckeckPromotersList.splice(index, 1)
          if(this.isckeckPromotersList.length == 0){
            this.designatedPromoters = false
          }
        } else {
          //type =='ing'
          //先把自己删掉
          this.checkingPromotersList.splice(index, 1)
          //再重新写入salesManIds，更新选中状态
          //同时更新selects，不能直接指针复制
          this.salesManIds = [];
          this.selects = [];
          // console.log('this.checkingPromotersList', this.checkingPromotersList)
          this.checkingPromotersList.map((item) => {
            this.salesManIds.push(item.id)
          });
          // console.log(this.selects)
          this.$refs.salesmuli.clearSelection();
          //这个方法不会清空已选，所以先清空再重选
          this.salesmanCheckToTrue(this.promotersTableData, false);
        }
      },
      // 获取默认的促销员
      getDefaultPromotersData(type, from) {
        //先重置
        this.promotersTotal = null;
        this.promotersTableData = [];

        this.promotersListLoading = true
        this.$http({
          method: "POST",
          url: "/rest/PublishedWork/searchSalesmans",
          data: Object.assign(
            this.paramForm, {
              projectStartTime: this.jobEditObj.requirementsStart,
              dto: {
                crescoreMin: this.publicStore2.crescoreMin,
                // crescoreMin: null,
                // crescoreMax: this.publicStore2.crescoreMax,
                // crescoreMax: null,
                searchType: this.searchType2_trans,
                // searchType: 0,
                storeCode: type == '任务编辑' ? this.jobEditObj.storeCode : this.storeInformation.storeCode,
                rankRuleId: this.jobInformation.rankRuleId,
                // rankRuleId: null,
                sex: this.publicStore.sex
              }
            })
 
        }).then(res => {
          let data = res.data
          this.promotersTotal = data.countSize
          this.salesFlag = data.flg
          this.promotersListLoading = false
          this.selects = [];
          this.promotersTableData = data.salesmanList
          //=='tableChange'
          this.salesmanCheckToTrue(this.promotersTableData, true)
        }).catch(err => {
          this.myNotify(this, 'error', err.response.message, '查询失败，请稍后重试')
          this.promotersListLoading = false
        })
      },
      salesmanCheckToTrue(arr, refresh) {
        arr.map((item) => {
          if (this.salesManIds.indexOf(item.id) > -1) {
            this.selects.push(item)
            if (refresh) {
              // 表格渲染需要时间，这里必须加延迟
              setTimeout(() => {
                this.$refs.salesmuli.toggleRowSelection(item, true)
              }, 200)
            } else {
              this.$refs.salesmuli.toggleRowSelection(item, true)
            }
          }
        })
      },
      //选择促销员信息变化时触发
      selectChange(selection, row) {
        //selection是所有选中的行，row是当前行
        // console.log('selection',selection)
        // console.log('row',row)
        // console.log('this.selects',this.selects)
        if (selection.length > this.selects.length) {
          // console.log(124124)
          //如果加了一个
          this.checkingPromotersList.push(row)
          this.salesManIds.push(row.id)
        } else {
          //如果减了一个
          this.checkingPromotersList.map((item, index, arr) => {
            if (item.id == row.id) {
              arr.splice(index, 1)
              this.salesManIds.splice(index, 1)
            }
          })
        }
        //记录当前的选项，不能直接指针赋值
        this.selects = []
        selection.map(item => {
          this.selects.push(item)
        })
      },
      //选择全部促销员时触发
      selectAllChange(selection) {
        if (selection.length > 0) {
          //如果是全选
          selection.map(item => {
            if (this.salesManIds.indexOf(item.id) < 0) {
              this.salesManIds.push(item.id)
              this.selects.push(item)
              this.checkingPromotersList.push(item)
            }
          })
        } else {
          //如果是取消全部选择
          this.selects = [];
          let delArr = [];
          this.promotersTableData.map(item => {
            this.checkingPromotersList.map((item2, index) => {
              if (item.id == item2.id) {
                delArr.unshift(index)
              }
            })
          })
          delArr.map(item => {
            this.checkingPromotersList.splice(item, 1)
          })
          this.salesManIds = [];
          this.checkingPromotersList.map(item => {
            this.salesManIds.push(item.id)
          })
        }

      },
      //促销员页size变化
      promotersHandleSizeChange(val) {
        this.paramForm.pageSize = val
        //这诡异的逻辑，看getPromotersData的注释就知道了
        if (this.salesFlag == 1) {//1是默认促销员
          this.getDefaultPromotersData(this.dialogTitle, 'tableChange')
        } else {//否则是搜索到的促销员
          this.getDefaultPromotersData(this.dialogTitle, 'tableChange')
        }

      },
      //促销员页pageno变化
      promotersHandleCurrentChange(val) {
        this.paramForm.pageNo = val
        //这诡异的逻辑，看getPromotersData的注释就知道了
        if (this.salesFlag == 1) {
          this.getDefaultPromotersData(this.dialogTitle, 'tableChange')
        } else {
          this.getDefaultPromotersData(this.dialogTitle, 'tableChange')
        }
      },
      //当在推送设定里勾选或取消指定促销员推送时触发
      promotersStatus() {
        if (!this.designatedPromoters) {
          //如果现在是不推送给促销员，则清空已选择的促销员及其转换好的idlist
          this.isckeckPromotersList = []
          this.salesmanIdList = []
        }
      },
      // 确认添加促销员
      addPromoter() {
        this.salesmanIdList = [];
        this.isckeckPromotersList = this.checkingPromotersList;
        this.isckeckPromotersList.forEach((item, index, arr) => {
          this.salesmanIdList.push(item.id)
        })
        this.addPromoterDialog = false
      },

      // 处理选择，取消选择
      selStore(type) {
        if (type == 'cancel') {
          this.$refs.selStoreTable.clearSelection();
          this.selStoreCnt = 0;
          this.selStoreAll = 'false';
          this.selTableData = [];//清空选择的数据
        } else if(type == 'page') {
          var rows = this.tableData;
          rows.forEach(row => {
            this.$refs.selStoreTable.toggleRowSelection(row,true);
          });
          this.selStoreCnt = rows.length;
          this.selStoreAll = 'false';
          this.selTableData = this.tableData;
        } else if(type == 'all') {
          var rows = this.tableData;
          rows.forEach(row => {
            this.$refs.selStoreTable.toggleRowSelection(row,true);
          });
          this.selStoreCnt = this.total ? (this.total > 1000 ? 1000 : this.total) : 0;
          this.selStoreAll = 'true';
          if(this.dataInType == 'maiJinBiao' || this.dataInType == 'menDianBiao') {
            this.selTableData = [];//清空选择的数据,后台自己查询所需数据
          }else {
            this.selStoreAll = 'false';
            this.selTableData = this.notOneKeyInData;//将导入的数据赋值给选中数据列表
          }
        }
      },
      // 如有点击事件选中门店，则取消数据全选状态，从新计数
      selectStoreChange(selection, row) {
        if(selection.length) {
          this.selStoreCnt = selection.length;
          this.selStoreAll = 'false';
          this.selTableData = selection;
        }else {
          this.selStoreCnt = 0;
          this.selStoreAll = 'false';
          this.selTableData = [];
        }
      },
      // 如有门店全选事件，则认为是本页全选，则取消数据全选状态，从新计数
      selectStoreAllChange(selection) {
        if (selection.length > 0) {
          //如果是全选
          this.selStoreCnt = this.tableData.length > 1000 ? 1000 : this.tableData.length;
          this.selStoreAll = 'false';
          this.selTableData = this.tableData;
        } else {
          //如果是取消全部选择
          this.selStoreCnt = 0;
          this.selStoreAll = 'false';
          this.selTableData = [];
        }
      },
    },
  }
</script>

<style scope lang="scss">

  .cutLine {
    border-right: 1px solid #82bc82;
    margin: 0 10px;
    position: relative;
    right: 1px;
  }

  .limitManagerTable .el-date-editor {
    width: 140px;
    height: 28px;
  }

  .limitManagerTable .el-input__inner {
    height: 28px;
  }

  .el-dialog--center .el-dialog__body {
    background: #fff;
  }

  .el-dialog--center .el-dialog__footer {
    padding-bottom: 10px;
  }

  .dialogContent {
    margin: 5px 10px 5px;
    .storeInformation {
      margin-bottom: 15px;
      display: flex;
      justify-content: flex-start;
      .detailInformation {
        width: 120px;
        text-align: center;
        word-wrap: break-word;
        border-right: 1px solid #f1f1f1;
        padding: 5px 10px 5px 10px;
        display: flex;
        flex-flow: column;
        .areaData {
          width: 100%;
          color: #333;
          font-size: 16px;
          // position: relative;
          // top:0px;

        }
        .blank {
          flex: 1
        }
        .area {
          width: 100%;
          color: #656565;
          font-size: 14px;
          // position: relative;
          // bottom:0px;
        }
      }
    }
    .recruitmentSettings {
      border-radius: 5px;
      // height:160px;
      background: #f8f8f8;
      .recruitmentSettingsTitle {
        height: 34px;
        line-height: 36px;
        color: #333;
        font-size: 16px;
        padding-left: 10px;
        border-bottom: 1px solid #fff;
      }
      .recruitmentSettingsDetailed {
        margin: 10px;
        padding-bottom: 10px;
        color: #656565;
        .salaryType {
          width: 110px;
        }
        .salaryType2 {
          width: 150px;
        }
        .salaryType .el-input__inner {
          border-radius: 30px;
        }
        .el-input__inner {
          height: 30px
        }
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #81bc82;
          border: 1px solid #81bc82
        }
        .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #656565;
        }
        .checkGround {
          margin: 0 0 0 20px;
          .ckeckPromoters {
            width: 90px;
            height: 25px;
            border-radius: 25px;
            background: #81bb81;
            border: 0;
            margin-left: 15px;
          }
        }
        .isckeckPromoters {
          margin: 0 0 0 20px;
          display: flex;
          // justify-content:flex-start;

          margin-top: 5px;
          .isckeckPromotersTitle {
            width: 80px;
            color: #333;
            margin: 5px 15px 0 0;
          }
          .isckeckPromotersContent {
            margin-top: 2.5px;
            flex: 1;
            .tag-list {
              // margin-bottom: 60px;
              .tag-item {
                display: inline-block;
                line-height: 30px;
                background-color: #8299dc;
                padding-left: 20px;
                padding-right: 10px;
                border-radius: 30px;
                margin-right: 10px;
                margin-bottom: 10px;
                color: #fff;
                .remove-btn {
                  display: inline-block;
                  width: 20px;
                  height: 20px;
                  vertical-align: middle;
                  margin-left: 20px;
                  margin-top: -2px;
                  background: url(../../../common/images/shan2.png) no-repeat center;
                }
              }
            }
          }
        }
        .rangeSetting1 {
          width: 90px;
        }
        .rangeSetting1 .el-input__inner {
          border-radius: 30px;
          background: #fff;
        }
        .trustArae {
          width: 90px
        }
      }
    }
    .addPromoter {
      .addPromoterDetailed {
        // margin: 10px;
        padding-bottom: 10px;
        color: #656565;

        .isckeckPromoters {
          // margin: 0 0 0 20px;
          display: flex;
          // justify-content:flex-start;

          margin-top: 5px;
          .isckeckPromotersTitle {
            width: 80px;
            color: #333;
            margin: 5px 15px 0 0;
          }
          .isckeckPromotersContent {
            margin-top: 2.5px;
            flex: 1;
            .tag-list {
              // margin-bottom: 60px;
              .tag-item {
                display: inline-block;
                line-height: 30px;
                background-color: #8299dc;
                padding-left: 20px;
                padding-right: 10px;
                border-radius: 30px;
                margin-right: 10px;
                margin-bottom: 10px;
                color: #fff;
                .remove-btn {
                  display: inline-block;
                  width: 20px;
                  height: 20px;
                  vertical-align: middle;
                  margin-left: 20px;
                  margin-top: -2px;
                  background: url(../../../common/images/shan2.png) no-repeat center;
                }
              }
            }
          }
        }
        .filterPromoters {
          width: 50px;
          height: 30px;
          border: 0;
          background: #2d2c7a;
          margin-left: 18px;

        }
        .tableContent {
          background: #f4f4f4;
          border-radius: 5px;
        }
      }
    }
  }

  .required {
    color: #f6914b;
  }

</style>



// WEBPACK FOOTER //
// src/views/workSquare/postJob/chooseStore.vue